document.addEventListener("DOMContentLoaded", () => {
  const getTrustPilotTotalz = async () => {
    try {
      // get totals
      const totalz = await fetch(
        "https://api.trustpilot.com/v1/business-units/61b021ae9580764bc1d19396?apikey=hm25GzJB7Yn7qV2KlezASDCoUZOZEWfR"
      );

      const totalzData = await totalz.json();
      const totalzReviews = totalzData.numberOfReviews.total;
      const totalzScore = totalzData.score.trustScore;

      const nonaTrustPilotStarss = document.querySelectorAll(
        ".nona-trust-pilot-stars"
      );
      const nonaTrustPilotTotals = document.querySelectorAll(
        ".nona-trust-pilot-total"
      );
      if (nonaTrustPilotStarss.length > 0 && nonaTrustPilotTotals.length > 0) {
        // on homepage get logo
        const starsUrl = totalzData.links.find(
          (l) => l.rel === "resources-images-stars"
        )?.href;
        const starsJson = await fetch(
          starsUrl + "?apikey=hm25GzJB7Yn7qV2KlezASDCoUZOZEWfR"
        );
        const starsData = await starsJson.json();

        const resourcesUrl = totalzData.links.find(
          (l) => l.rel === "resources-strings-stars"
        )?.href;
        const resourcesJson = await fetch(
          resourcesUrl + "?apikey=hm25GzJB7Yn7qV2KlezASDCoUZOZEWfR"
        );
        const resources = await resourcesJson.json();
        nonaTrustPilotStarss.forEach((star) => {
          star.src = starsData.star256x48.url;
          star.classList.remove("hide");
        });
        nonaTrustPilotTotals.forEach((total) => {
          total.innerText = totalzScore + "/5 - " + totalzReviews + " reviews";
        });
      }


        const ddoccPrice = document.getElementById("product-price");
        if(ddoccPrice){

          ddoccPrice.querySelector(".starsSTARS").style.display = "none";
          ddoccPrice.querySelector(".hideIfNoReview").style.display = "none";
          document.getElementById('totalScore').innerHTML = `Trustscore ${totalzScore}`;
          document.getElementById('numberOfReviews').innerHTML = `Based on ${totalzReviews} reviews`;
        }
    } catch (e) {
      console.log("🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥error getting reviews", e);
    }
  };

  getTrustPilotTotalz();
});
